import { getMockData } from './MockData';
import { AccountsColumns } from '../../../services/column-definitions';

export const getDataGridProps = () => ({ rows: getMockData(), columns: AccountsColumns() });
